import React from 'react';
import { Row, Col } from 'antd';
import foodImage1 from '../../assets/images/food/food-1.jpeg';
import foodImage2 from '../../assets/images/food/food-2.jpeg';
import foodImage3 from '../../assets/images/food/food-3.jpeg';
import foodImage4 from '../../assets/images/food/food-4.jpeg';

import FoodItemCard from '../FoodItemCard';

const foodList = [
  { key: '1', cover: foodImage1 },
  { key: '2', cover: foodImage2 },
  { key: '3', cover: foodImage3 },
  { key: '4', cover: foodImage4 },
  { key: '5', cover: foodImage1 },
  { key: '6', cover: foodImage2 },
  { key: '7', cover: foodImage3 },
  { key: '8', cover: foodImage4 },
  { key: '9', cover: foodImage1 },
  { key: '10', cover: foodImage2 },
  { key: '11', cover: foodImage3 },
  { key: '12', cover: foodImage4 },
  { key: '13', cover: foodImage1 },
  { key: '14', cover: foodImage2 },
  { key: '15', cover: foodImage3 },
  { key: '16', cover: foodImage4 }
];

const FoodItemsList: React.FC = (Props: any) => {
  return (
    <Row gutter={[16, 24]}>
      {foodList.map((item) => (
        <Col xs={24} sm={24} md={8} lg={6} xl={6} xxl={4} key={item.key}>
          <FoodItemCard name={item.cover} />
        </Col>
      ))}
    </Row>
  );
};

export default FoodItemsList;
